
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./js/app.js";
              export default OriginalModule.default;
              export * from "./js/app.js";